module.exports = __webpack_public_path__ + "static/media/clearIcon.a7f6e698.svg";